var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.8V17.8",
    stroke: "#74767B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19995 10L2.19995 10",
    stroke: "#74767B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 10L15.8 10",
    stroke: "#74767B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.2V4.2",
    stroke: "#74767B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L4 4",
    stroke: "#74767B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91888 3.91888C2.51198 5.32578 1.63643 7.17698 1.44141 9.15705C1.24639 11.1371 1.74397 13.1236 2.84936 14.7779C3.95475 16.4322 5.59957 17.6521 7.50355 18.2297C9.40753 18.8073 11.4529 18.7068 13.2911 17.9454C15.1293 17.184 16.6466 15.8087 17.5845 14.054C18.5224 12.2993 18.8229 10.2736 18.4348 8.32222C18.0466 6.3708 16.9938 4.61433 15.4558 3.35211C13.9178 2.08989 11.9897 1.4 10 1.4",
    stroke: "#74767B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.ba8d1e5555640bee6e4ddb7245b1d5fe.svg";
export { ForwardRef as ReactComponent };